import React, { useEffect, useState } from 'react';
import './AdminDashboard.css';
import {
  FaUserCog, FaFileAlt, FaNewspaper, FaHardHat, FaShieldAlt, FaBook,
  FaHeartbeat, FaSeedling, FaTint, FaMoneyBillWave, FaWpforms,
  FaFolderOpen, FaComments, FaUserPlus
} from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const AdminDashboard = () => {
  const [decodedData, setDecodedData] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');

    // Ensure token exists before decoding
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setDecodedData(decoded);
      } catch (err) {
        console.error('Invalid token:', err);
        // Handle invalid token if necessary (e.g., redirect to login)
        navigate('/login');
      }
    }
  }, [navigate]);

  const userRoles = decodedData?.userRoles || [];

  return (
    <div className="admin-dashboard">
      <h1>Welcome to the Management Dashboard</h1>

      <div className="admin-dashboard-grid">

        {userRoles.includes('admin') && (
          <Link to="/admin-users" className="admin-dashboard-card">
            <FaUserCog className="admin-dashboard-icon" />
            <h3>Manage Users</h3>
            <p>View, create, edit, or delete user accounts.</p>
          </Link>
        )}

        {userRoles.includes('admin') && (
          <Link to="/admin-reports" className="admin-dashboard-card">
            <FaFileAlt className="admin-dashboard-icon" />
            <h3>Manage Reports</h3>
            <p>Create, update, or delete reports.</p>
          </Link>
        )}

        {(userRoles.includes('admin') || userRoles.includes('events & media')) && (
          <Link to="/admin-posts" className="admin-dashboard-card">
            <FaNewspaper className="admin-dashboard-icon" />
            <h3>Manage News & Events</h3>
            <p>Create, update, and delete news & events.</p>
          </Link>
        )}

        {(userRoles.includes('admin') || userRoles.includes('works')) && (
          <Link to="/admin-posts" className="admin-dashboard-card">
            <FaHardHat className="admin-dashboard-icon" />
            <h3>Manage Works Updates</h3>
            <p>Create, update, and delete works updates.</p>
          </Link>
        )}

        {(userRoles.includes('admin') || userRoles.includes('security')) && (
          <Link to="/admin-posts" className="admin-dashboard-card">
            <FaShieldAlt className="admin-dashboard-icon" />
            <h3>Manage Security Updates</h3>
            <p>Create, update, and delete security updates.</p>
          </Link>
        )}

        {(userRoles.includes('admin') || userRoles.includes('education')) && (
          <Link to="/admin-posts" className="admin-dashboard-card">
            <FaBook className="admin-dashboard-icon" />
            <h3>Manage Education Updates</h3>
            <p>Create, update, and delete education updates.</p>
          </Link>
        )}

        {(userRoles.includes('admin') || userRoles.includes('health')) && (
          <Link to="/admin-posts" className="admin-dashboard-card">
            <FaHeartbeat className="admin-dashboard-icon" />
            <h3>Manage Health Updates</h3>
            <p>Create, update, and delete health updates.</p>
          </Link>
        )}

        {(userRoles.includes('admin') || userRoles.includes('agriculture')) && (
          <Link to="/admin-posts" className="admin-dashboard-card">
            <FaSeedling className="admin-dashboard-icon" />
            <h3>Manage Agriculture Updates</h3>
            <p>Create, update, and delete agriculture updates.</p>
          </Link>
        )}

        {(userRoles.includes('admin') || userRoles.includes('wash')) && (
          <Link to="/admin-posts" className="admin-dashboard-card">
            <FaTint className="admin-dashboard-icon" />
            <h3>Manage WASH Updates</h3>
            <p>Create, update, and delete WASH updates.</p>
          </Link>
        )}

        {(userRoles.includes('admin') || userRoles.includes('finance')) && (
          <Link to="/admin-posts" className="admin-dashboard-card">
            <FaMoneyBillWave className="admin-dashboard-icon" />
            <h3>Manage Finance Updates</h3>
            <p>Create, update, and delete finance updates.</p>
          </Link>
        )}

        {userRoles.includes('admin') && (
          <Link to="/admin-forms" className="admin-dashboard-card">
            <FaWpforms className="admin-dashboard-icon" />
            <h3>Manage Forms</h3>
            <p>Create, update, and delete forms.</p>
          </Link>
        )}

        {userRoles.includes('admin') && (
          <Link to="/admin-our-team" className="admin-dashboard-card">
            <FaUserPlus className="admin-dashboard-icon" />
            <h3>Manage Team</h3>
            <p>View and manage Our Team.</p>
          </Link>
        )}

        {(userRoles.includes('admin') || userRoles.includes('events & media')) && (
          <Link to="/admin-gallery" className="admin-dashboard-card">
            <FaUserPlus className="admin-dashboard-icon" />
            <h3>Manage Gallery</h3>
            <p>View and manage Gallery.</p>
          </Link>
        )}

        {userRoles.includes('admin') && (
          <Link to="/admin-applications" className="admin-dashboard-card">
            <FaFolderOpen className="admin-dashboard-icon" />
            <h3>Manage Applications</h3>
            <p>View and manage user applications.</p>
          </Link>
        )}

        {userRoles.includes('admin') && (
          <Link to="/admin-feedbacks" className="admin-dashboard-card">
            <FaComments className="admin-dashboard-icon" />
            <h3>User Feedback</h3>
            <p>View and respond to citizen feedback.</p>
          </Link>
        )}

      </div>
    </div>
  );
};

export default AdminDashboard;